import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';

import { WorkspaceRoleV2 } from 'modules/CreateWorkspaceModal/types';
import useWorkspacesContext from 'modules/Workspaces/WorkspacesProvider/useWorkspacesContext';
import { PermissionId, workspacesConfig } from 'utils/powerLevelsConfig';
import { getWorkspaceRolesSchema } from 'utils/yup/schemas/validationSchemas';

import { WorkspaceRolesFormType } from '../../../CreateWorkspaceModal/WorkspaceRoleCreate/useWorkspaceRolesForm';

const useWorkspaceRoleEditForm = (roleId: string, initialName: string, role: WorkspaceRoleV2) => {
  const { workspaceRoles } = useWorkspacesContext();

  const initialPermissionsRecord = Object.values(workspacesConfig).reduce(
    (acc, entry) => {
      acc[entry.id] = role.powerLevels[entry.scope] >= entry.powerLevel;
      return acc;
    },
    {} as Record<PermissionId, boolean>
  );

  const form = useForm<WorkspaceRolesFormType>({
    mode: 'all',
    resolver: yupResolver(getWorkspaceRolesSchema(workspaceRoles, roleId)),
    defaultValues: {
      roleName: initialName,
      permissions: initialPermissionsRecord,
    },
  });

  return form;
};

export default useWorkspaceRoleEditForm;
